export enum UserOrganizationSearchOrder {
  OrderByUserOrganizationId = 1,
  OrderByFirstName = 2,
  OrderByLastName = 3,
  OrderByOidcIdentity = 5,
  OrderByAdfsIdentity = 6,
  OrderByEmail = 7,
  OrderByRole = 8,
  OrderByState = 9,
}
